module.exports = __webpack_public_path__ + "img/shape-60.ca5c992b.svg";